<div class="p-5 modal-scrollable">
  <div class="card">
    <app-loading-overlay-modal *ngIf="loading"></app-loading-overlay-modal>
    <div class="card-title m-0">
      <h3 class="fw-bold m-0 p-4 fs-6">Add New Importer</h3>
    </div>

    <form class="form" [formGroup]="form">
      <div class="border-top p-4">
        <div class="row mb-4">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Name <app-rl></app-rl></label>
          <div class="col-lg-8">
            <app-text-input formControlName="name" placeholder="Enter importer name"></app-text-input>
            <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'name'">
            </app-validation-message>
          </div>
        </div>
        <div class="row mb-4">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Description <app-ol></app-ol></label>
          <div class="col-lg-8">
            <app-textarea-input formControlName="description" [placeholder]="'Enter importer description'"
              [iconClass]="'bi-person fw-bold'"></app-textarea-input>
            <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'description'">
            </app-validation-message>
          </div>
        </div>
        <div class="row mb-4">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Importer Status<app-rl></app-rl></label>
          <div class="col-lg-8">
            <app-status-input formControlName="status"></app-status-input>
            <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'status'">
            </app-validation-message>
          </div>
        </div>

        <h3 class="fw-bold pt-5 mb-3 pb-2 fs-6">
          Contact Details
        </h3>
        <hr class="mb-3">
        <div class="row mb-4">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Address <app-ol></app-ol></label>
          <div class="col-lg-8">
            <app-text-input formControlName="address" [placeholder]="'Enter importer address'"></app-text-input>
            <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'address'">
            </app-validation-message>
          </div>
        </div>
        <div class="row mb-4">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Country <app-ol></app-ol></label>
          <div class="col-lg-8">
            <app-text-input formControlName="country" [placeholder]="'Enter importer country'"></app-text-input>
            <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'country'">
            </app-validation-message>
          </div>
        </div>
        <div class="row mb-4">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Email <app-ol></app-ol></label>
          <div class="col-lg-8">
            <app-email-input formControlName="email" [placeholder]="'Enter importer email'"></app-email-input>
            <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'email'">
            </app-validation-message>
          </div>
        </div>
        <div class="row mb-4">
          <label class="col-lg-4 col-form-label fw-semibold fs-8">Phone Number <app-ol></app-ol></label>
          <div class="col-lg-8">
            <app-phone-input formControlName="phone_number" [placeholder]="'Enter importer phone number'">
            </app-phone-input>
            <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'phone_number'">
            </app-validation-message>
          </div>
        </div>
        <div class="border-top d-flex justify-content-end pt-4 pb-4">
          <button type="reset" class="btn btn-lg btn-light me-2">Discard</button>
          <button (click)="save()" class="btn btn-lg btn-primary">
            <span *ngIf="!loading"> <i class="bi bi-check-all fw-semibold me-2"></i>
              Save</span>
            <span *ngIf="loading">
              <app-spinner></app-spinner> Please, wait ...
            </span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
